export enum AnalyticsDataType {
  daily,
  annual,
}
